// Çıkan miktar değişken reçeteler: beklenen aralığı ölçekleme ve uyarı metni (sunucuyla aynı kural).
import { formatQuantity } from './productionFormat';

export interface ExpectedRange {
  min: number | null;
  max: number | null;
}

function round3(value: number): number {
  return Math.round((value + Math.sign(value) * Number.EPSILON) * 1000) / 1000;
}

function hasValue(value: number | null | undefined): value is number {
  return value != null && Number.isFinite(value);
}

/** Aralık reçete partisi (batch) içindir; planlanan / batch ile ölçeklenir, 3 hane. */
export function scaleExpectedRange(
  min: number | null | undefined,
  max: number | null | undefined,
  batch: number | null | undefined,
  planned: number | null | undefined,
): ExpectedRange | null {
  if (!hasValue(min) && !hasValue(max)) return null;
  if (!batch || batch <= 0 || !planned || planned <= 0) return null;
  const factor = planned / batch;
  return {
    min: hasValue(min) ? round3(min * factor) : null,
    max: hasValue(max) ? round3(max * factor) : null,
  };
}

/** Sunucu aralığı fişin planlananı içindir; dialogdaki planlanan farklıysa oranlanır. */
export function rescaleRange(range: ExpectedRange | null, fromPlanned: number, toPlanned: number): ExpectedRange | null {
  if (!range || fromPlanned <= 0 || toPlanned <= 0 || Math.abs(fromPlanned - toPlanned) < 1e-9) return range;
  const factor = toPlanned / fromPlanned;
  return {
    min: range.min != null ? round3(range.min * factor) : null,
    max: range.max != null ? round3(range.max * factor) : null,
  };
}

export function isOutsideRange(produced: number, range: ExpectedRange | null): boolean {
  if (!range || !Number.isFinite(produced) || produced <= 0) return false;
  return (range.min != null && produced < range.min) || (range.max != null && produced > range.max);
}

export interface RangeLabels {
  atLeast: string;
  atMost: string;
}

const TR_LABELS: RangeLabels = { atLeast: 'en az', atMost: 'en fazla' };

/** Aralık metni: "250–280 adet", "en az 250 adet". */
export function formatRange(range: ExpectedRange | null, unit?: string | null, labels: RangeLabels = TR_LABELS): string {
  if (!range) return '';
  if (range.min != null && range.max != null) return `${formatQuantity(range.min)}–${formatQuantity(range.max, unit)}`;
  if (range.min != null) return `${labels.atLeast} ${formatQuantity(range.min, unit)}`;
  return `${labels.atMost} ${formatQuantity(range.max, unit)}`;
}

/** "Çıkan 230 adet; beklenen 250–280 adet." Aralık içindeyse null. */
export function outputRangeWarning(produced: number, range: ExpectedRange | null, unit?: string | null): string | null {
  if (!range || !isOutsideRange(produced, range)) return null;
  return `Çıkan ${formatQuantity(produced, unit)}; beklenen ${formatRange(range, unit)}.`;
}
